import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import ReactHookToast from "@core/styles/react-hot-toast";
import Layout from "./Layout";
import Login from "pages/login";
import Error404 from "pages/404";
import { logOut, loginUserData, permission } from "store/reducer/AuthReducer";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Storage from "@core/helper/Storage";
import Emitter from "@core/helper/Emitter";

const MainPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { settings, saveSettings } = props;
  const { isLogin, isPermission } = useSelector((state) => state.auth);
  const location = useLocation();
  const logOutListener = useRef();

  useEffect(() => {
    const value = localStorage.getItem("@userData");
    if (value === null && !isLogin && location.pathname !== "/login") {
      navigate("/login");
    } else {
      if (location.pathname === "/") {
        navigate("/dashboard");
      }
    }

    if (location.pathname === "/error") {
      navigate("/error");
    }
  }, [isLogin, location, navigate]);

  useEffect(() => {
    const value = localStorage.getItem("@userData");
    const valuedata = JSON.parse(value);
    if (valuedata) {
      const data = valuedata.data;
      dispatch(loginUserData({ data }));
    }
  }, [dispatch]);

  const setupLogoutListener = () => {
    logOutListener.current = Emitter.addListener("logout", async () => {
      Storage.logOutUser();
      dispatch(logOut());
      await Storage.getUserData();
      navigate("/login");
    });
  };

  const valuenavigation = () => {
    let path = _.split(location.pathname, "/");
    path = _.filter(path, (i) => i !== "");
    path = _.map(path, (i) => _.capitalize(i));
    path = path.join(" | ");
    document.title = path;

    if (location.pathname === "/calendersetting/hijricalender") {
      document.title = "Calender Setting | Hijri Calender";
    } else if (location.pathname === "/calendersetting/specialdays") {
      document.title = "Calender Setting | Special Days";
    } else if (location.pathname === "/createsubadmin") {
      document.title = "Sub Admin";
    } else if (location.pathname === "/donationtype") {
      document.title = "Donation Type";
    } else if (location.pathname === "/generalsetting") {
      document.title = "General Setting";
    } else if (location.pathname === "/calendersetting") {
      document.title = "Calendar Setting";
    }
    // else if (location.pathname === "/daysadjustment") {
    //   document.title = "Day's Adjustment";
    // }
  };

  useEffect(() => {
    setupLogoutListener();
    valuenavigation();
    return () => {
      logOutListener.current.remove();
    };
  }, [location]);

  const Admindetail = () => {
    APICall("get", null, EndPoints.getAdminDetail).then(async (response) => {
      const { isError, data } = response.data;
      if (!isError && response.status === 200) {
        dispatch(permission());
        const localdata = localStorage.getItem("@userData");
        const datavalue = JSON.parse(localdata);
        const valuechange = Object.entries(datavalue).map(([key, value]) => {
          const obj2 = {
            dashboard: {
              view: true,
              edit: true,
              delete: true,
            },
            ...data[0].config,
          };

          data[0].config = obj2;
          value.user.config = data[0].config;
          return value;
        });
        global.userData = valuechange[0];
        localStorage.setItem("@userData", JSON.stringify(valuechange[0]));
        Storage.setUserData({ data: valuechange[0] });
        dispatch(loginUserData({ data: valuechange[0] }));
        valuenavigation();
        await Storage.getUserData();
        const dataset1 = JSON.parse(JSON.stringify(valuechange[0]));
        const datavalue1 = dataset1?.user;
        const pushdata = [];

        Object.entries(datavalue1?.config).map(([key, value]) => {
          if (!value.view && !value.edit && !value.delete) {
          } else {
            pushdata.push(key);
          }
        });
        const split = _.split(pushdata[0], "_").join("");
        if (datavalue1.role === "2") {
          if (split === "program") {
            navigate("/program/today");
          } else if (split === "library") {
            navigate("/library/category");
          } else if (split === "business") {
            navigate("/business/category");
          } else if (split === "donation") {
            navigate("/donation/donation");
          } else if (split === "calendersetting") {
            navigate("/calendersetting/hijricalender");
          } else if (split === "day'sadjustment") {
            navigate("/daysadjustment");
          } else {
            navigate(`/${split}`);
          }
        } else {
          navigate("/dashboard");
        }
      }
    });
  };

  useEffect(() => {
    Storage.getUserData().then((e) => {
      const { userData } = global;
      if (userData) {
        Admindetail();
      }
    });
  }, []);

  return (
    <>
      {!isLogin ? (
        <Routes>
          <Route exact path="/login" element={<Login />} />
        </Routes>
      ) : (
        isPermission && (
          <Layout settings={settings} saveSettings={saveSettings} />
        )
      )}
      <Routes>
        <Route exact path="/error" element={<Error404 />} />
      </Routes>
      <ReactHookToast>
        <Toaster
          position={settings.toastPosition}
          toastOptions={{ className: "react-hot-toast" }}
        />
      </ReactHookToast>
    </>
  );
};

export default MainPage;
